import { GoogleMap } from './MapsDynamicLoader';
import { when } from 'mobx';
import { IGeoLocation } from '~domain/entities/UserLocation';

export const awaitMapThenFitBoundsOrPan = async (
    map: GoogleMap,
    numberOfStores: number,
    searchLocation: IGeoLocation
) => {
    await when(() => !!map);
    if (numberOfStores) {
        map.fitBoundsByMarkers();
    } else {
        map.panTo({
            latitude: searchLocation.lat,
            longitude: searchLocation.lng
        });
    }
};
